var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"laudos"}},[_c('ModalOpcoes',{on:{"update:lista":_vm.requestLaudos,"showModalOpcoes":_vm.changeShowModalOpcoes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }